export default {
  getDossierContact(state) {
    return state.dossier.contacts
  }
}
